import React, {Component} from 'react';
import UsersList from './UsersList';
import UserService from './services/user.serviceaux';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import * as FaIcons from "react-icons/fa";
import { Button, Container, FormControl, FormLabel, Row, Col } from 'react-bootstrap';
import ExportSidebar from './ProSideBar';
import NoPrivileges from './NoPrivileges';
import Sidebar from './Sidebar';
import { PageHeader } from "./AuxiliaryFunctions";


var newDate = new Date()
var gtDate = newDate.getDate().toString().padStart(2,'0') + '-' + (newDate.getMonth()+1).toString().padStart(2,'0') + '-' + newDate.getFullYear()

const UsersAuth = () => {
  const { user: currentUser } = useSelector((state) => state.auth) 
  // Admin role is id = 3
  // Superadmin role is id = 4
  return (
    (currentUser.roles.includes(4))?(<Users />):
    <>
      <NoPrivileges currentUser={currentUser}/>
    </>
  )
}

class Users extends Component {
  
  constructor(props) {
    super(props);
    this.onChangeUserName = this.onChangeUserName.bind(this);
    this.onChangeEmail = this.onChangeEmail.bind(this);
    this.onChangeUserFilterByDescr = this.onChangeUserFilterByDescr.bind(this);
    this.onChangeSortField = this.onChangeSortField.bind(this);
    this.onChangeSortType = this.onChangeSortType.bind(this);
    this.performSearch = this.performSearch.bind(this);    

    this.state = {
      username: '',
      email: '',
      listOfUsers: [],
      UserFilterByDescr: '',
      SortField: 'createdAt',
      SortType: 'DESC',   
    };
  }  

  onChangeSortType() {
    this.setState({
      SortType: (this.state.SortType == 'DESC')?'ASC':'DESC'
    });
    this.performSearch(this.state.UserFilterByDescr,this.state.SortField,this.state.SortType);    
  }

  onChangeSortField(e) {
    this.setState({
      SortField: e.target.value
    });
    this.performSearch(this.state.UserFilterByDescr,e.target.value,this.state.SortType);
  }

  onChangeUserFilterByDescr(e) {
    this.setState({
      UserFilterByDescr: e.target.value
    });
    this.performSearch(e.target.value,this.state.SortField,this.state.SortType);
  }  

  componentDidMount() {  
    this.performSearch(this.state.UserFilterByDescr, this.state.SortField,this.state.SortType);  
  }

  onChangeUserName(e) {
    this.setState({
        username: e.target.value
    });
  }

  onChangeEmail(e) {
    this.setState({
        email: e.target.value
    });
  }  



  performSearch = (descr,sortfield,sorttype) => {
    UserService.getUserByDescr(descr,sortfield,sorttype)
      .then(response => {
        this.setState({
          listOfUsers: response.data
        });
      })
      .catch(e => {
        console.log(e);
      });
  };

  searchWithEnter = (event)=> {
    if (event.keyCode === 13) {
      this.performSearch();
    }
  } 

  render (){
    return (
      <>
      <Sidebar />
      <div style={{display:'flex', flexDirection:'row', gap:'10px'}}>
        <ExportSidebar />      
        <Container>
          <Row className='mb-2 d-flex'>
            <FormLabel style={{fontSize:"0.8em",textAlign:"right"}}>Fecha de hoy: {gtDate}</FormLabel>
            <hr/>
            
            <h5 style={{width: "100%", textAlign: "center", marginLeft: "0%", color: "green" }}>Usuarios</h5>
            <Col lg={true}>
              <FormLabel className='mb-2'>Filtrar por nombre de usuario:</FormLabel>       
              <FormControl type="text" name="filterbyusername" id="filterbyusername" onChange={this.onChangeUserFilterByDescr}></FormControl>
            </Col>
            <Col lg={true}>
              <FormLabel className='mb-2'>Ordenar por:</FormLabel>       
              <FormControl as='select' onChange={this.onChangeSortField}>
                <option value="createdAt">Fecha de creación</option>
                <option value="telefonomovil">Teléfono</option>
                <option value="primernombre">Primer Nombre</option>
              </FormControl>
            </Col>
              
            <Col sm={true}>
              <FormLabel className='mb-2'>Asc/Desc:</FormLabel>       
              <FormControl style={{maxWidth:"50px"}} as="button" onClick={this.onChangeSortType}><FaIcons.FaSortAmountDownAlt/></FormControl>
            </Col>          
          </Row>

          <Link to="/new-user" className="mr-2 btn btn-secondary">Nuevo usuario</Link>            

          <Button className="m-2 btn btn-secondary">Exportar</Button>        
          <Row>
            <UsersList mode={0} listOfUsers = {this.state.listOfUsers} />      
          </Row>
        </Container>        
      </div>
      
      </>
    )
  }
}

export default UsersAuth;